import React from 'react'
import "./Workmain.css"

function Work_main() {
	return (
		<div>
			<section>
				<div class="container">
					<div class="row">
						<div class="col-md-12">
							<h1>How It Works</h1>
						</div>
					</div>
					<div class="row">
						<div class="col-md-12">
							<div class="steps d-flex" >
								<div class="col-md-2">
									<img src="1.svg" />
									<p>STEP 1</p>
									<h5>Choose a Pair and select the best rate</h5>

								</div>
								<div class="col-md-1">
									<i class="fa fa-arrow-right" aria-hidden="true" style={{ paddingTop: "60px" }}></i>
								</div>
								<div class="col-md-2">
									<img src="2.svg" />
									<p>STEP 2</p>
									<h5>Enter the recipient wallet address</h5>
								</div>
								<div class="col-md-1">
									<i class="fa fa-arrow-right" aria-hidden="true" style={{ paddingTop: "60px" }}></i>
								</div>
								<div class="col-md-2">
									<img src="3.svg" />
									<p>STEP 3</p>
									<h5>Transfer Funds</h5>
								</div>
								<div class="col-md-1">
									<i class="fa fa-arrow-right" aria-hidden="true" style={{ paddingTop: "60px" }}></i>
								</div>
								<div class="col-md-2">
									<img src="4.svg" />
									<p>STEP 4</p>
									<h5>Receive your coins</h5>
								</div>
							</div>
						</div>
					</div>
					<br />
					<br />

					<div class="row">
						<div class="col-md-2">
							<div class="one">
								1
							</div>
						</div>

						<div class="col-md-5">
							<h1>
								Select the amount and the exchange service
							</h1>
							<p class="Workpara">
								Here is the simple 4-step tutorial on how to exchange cryptocurrency on SwapSpace. We’ll tell you how to exchange ETH to BTC in this tutorial, but, of course, it applies to any other pair. To buy some Bitcoin with your Ethereum, first you need to choose ETH in the “You send” and BTC in the “You get” section. You should also enter the amount of ETH you want to exchange in the “You send” section. Next, press the ”View offers” button.
							</p>

						</div>
						<div class="col-md-1"></div>
						<div class="col-md-4">
							<img src="swap.png" width="100%" />

						</div>
					</div>
					<br />
					<div class="row">
						<div class="col-md-2">

						</div>
						<div class="col-md-6">
							<img src="swap1.png" width="100%" />

						</div>
						<div class="col-md-4">
							<p class="Workpara">
								SwapSpace offers both fixed and floating exchange flows – use the sorting feature or just look at the icons next to the rates to choose what suits you best! When you’ve decided on the most fitting offer for you, click on the “Exchange” button.
							</p>

						</div>
					</div>
					<br />
					<br />
					<div class="row">
						<div class="col-md-2">
							<div class="one">
								2
							</div>
						</div>
						<div class="col-md-4">
							<h3>
								Enter the recipient wallet address
							</h3>
							<p class="Workpara">
								Fill in the “Provide the BTC address” field with the destination Bitcoin address — i.e. the address where you want to get your coins after the exchange — and provide the refund address if you want. If your preferred wallet is either SimpleHold or Trezor, you can press the button to connect a wallet and simplify the exchange process (more on that — in our FAQ ). Check the information carefully and click the “Next” button.
							</p>

						</div>
						<div class="col-md-1"></div>

						<div class="col-md-5">
							<img src="swap2.png" width="100%" />

						</div>
					</div>
					<br />
					<div class="row">
						<div class="col-md-2">
							<div class="one">
								3
							</div>
						</div>
						<div class="col-md-4">
							<h3>
								Transfer your funds
							</h3>
							<p class="Workpara">
								Using the wallet of your choice, send your Ethereum to the address you see on the screen. You can use the QR-code to speed up the process. If you’ve connected your SimpleHold or Trezor wallet ( FAQ ), you can press “Send it with SimpleHold” or “Send it with Trezor” respectively. As soon as our partner gets your ETH, the exchange will continue.
							</p>

						</div>
						<div class="col-md-1"></div>

						<div class="col-md-5">
							<img src="swap3.png" width="100%" />

						</div>
					</div>
					<br />
					<div class="row">
						<div class="col-md-2">
							<div class="one">
								4
							</div>
						</div>
						<div class="col-md-4">
							<h3>
								Wait until the exchange is processed
							</h3>
							<p class="Workpara">
								At this stage, you just need to wait until you get your coins in the wallet. Check the Swap Tracker if you want to know the exchange status, and feel free to contact the support if it seems like something is going wrong. That’s it!
							</p>

						</div>
						<div class="col-md-1"></div>

						<div class="col-md-5">
							<img src="swap4.png" width="100%" />

						</div>
					</div>
				</div>
			</section>
		</div>
	)
}

export default Work_main
